import React, { lazy, Suspense } from 'react';

const LazyRoleUserManagement = lazy(() => import('./RoleUserManagement'));

const RoleUserManagement = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyRoleUserManagement {...props} />
  </Suspense>
);

export default RoleUserManagement;
